export const getDimensionData = dimensionData => {
  if (Object.keys(dimensionData).length) {
    const {
      ProductDimensionAttributes = [],
      ProductDimensionAttributesValues = [],
      ProductSpecificationAttributesValues = [],
    } = dimensionData
    const {
      Specification = "[]",
      Dimension = "[]",
      enable: enabled = false,
    } = ProductDimensionAttributes[0] ?? {}
    const specification = JSON.parse(Specification)
    const dimension = JSON.parse(Dimension)

    const processedData = {
      enabled,
      dimensions: dimension?.map((d, idx) => {
        return {
          key: idx + 1,
          label: d.label,
          value: ProductDimensionAttributesValues?.[0]?.[d.pimAttribute] || "",
          tooltip: d.tooltip,
          unit: d.unit,
        }
      }),
      specifications:
        specification.length && specification[0].label.length
          ? specification?.map((s, idx) => {
              return {
                key: idx + 1,
                label: s.label,
                value:
                  ProductSpecificationAttributesValues?.[0]?.[s.pimAttribute] ||
                  "",
                tooltip: s.tooltip,
                unit: s?.unit ?? "",
              }
            })
          : [],
    }
    return processedData
  }

  return {}
}
